import { render, staticRenderFns } from "./VerifyDepositsAmount.vue?vue&type=template&id=90c4e364&"
import script from "./VerifyDepositsAmount.vue?vue&type=script&lang=ts&"
export * from "./VerifyDepositsAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports